module.exports = __webpack_public_path__ + "img/my_head.461427f0.png";